var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{staticClass:"cursor-pointer",attrs:{"outlined":""}},[_vm._v("\n    "+_vm._s(_vm.bolean ? 'Si' : 'No')+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }